import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_BASE_URL}/ptt`;

// Create axios instance with auth token
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Channel APIs
export const createChannel = async (channelData) => {
  const response = await api.post('/channels', channelData);
  return response.data;
};

export const getUserChannels = async () => {
  const response = await api.get('/channels');
  return response.data;
};

export const getChannel = async (channelId) => {
  const response = await api.get(`/channels/${channelId}`);
  return response.data;
};

export const joinChannel = async (channelId) => {
  const response = await api.post(`/channels/${channelId}/join`);
  return response.data;
};

export const leaveChannel = async (channelId) => {
  const response = await api.post(`/channels/${channelId}/leave`);
  return response.data;
};

// Message APIs
export const sendTextMessage = async (channelId, textContent, replyToId = null) => {
  const response = await api.post(`/channels/${channelId}/messages`, {
    textContent,
    replyToId,
  });
  return response.data;
};

export const uploadVoiceMessage = async (channelId, audioBlob, duration) => {
  const formData = new FormData();
  formData.append('audio', audioBlob, 'voice-message.webm');
  formData.append('duration', duration);
  formData.append('format', 'webm');
  
  const response = await api.post(
    `/channels/${channelId}/messages/voice`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};

export const getChannelMessages = async (channelId, limit = 50, cursor = null) => {
  const params = { limit };
  if (cursor) params.cursor = cursor;
 
  const response = await api.get(`/channels/${channelId}/messages`, { params });
  return response.data;
};

export const deleteMessage = async (messageId) => {
  const response = await api.delete(`/messages/${messageId}`);
  return response.data;
};

// User status APIs
export const getUserStatus = async (infinityCode) => {
  const response = await api.get(`/users/${infinityCode}/status`);
  return response.data;
};

export const getChannelOnlineUsers = async (channelId) => {
  const response = await api.get(`/channels/${channelId}/online-users`);
  return response.data;
};

export const getChannelStatistics = async (channelId) => {
  const response = await api.get(`/channels/${channelId}/statistics`);
  return response.data;
};

// NEW: Get all online users for direct chat
export const getAllOnlineUsers = async () => {
  const response = await api.get('/users/online/all');
  return response.data;
};

// NEW: Create or get direct channel with a user
export const createDirectChannel = async (targetUserCode) => {
  const response = await api.post('/channels/direct/create', {
    targetUserCode
  });
  return response.data;
};

export const getAllEmployees = async () => {
  const response = await api.get('/employees/all');
  return response.data;
};

export default api;